import React from 'react';
import FormSection from '../FormElements/FormSection';
import FormSubmit from '../FormElements/FormSubmit';
import Label from '../FormElements/Label';
import TextInput from '../FormElements/TextInput';
import TextArea from '../FormElements/TextArea';
import EmailInput from '../FormElements/EmailInput';

const IssueForm = ({
	name,
	email,
	description,
	errors,
	isSubmitted,
	onChange,
	onSubmit
}) => {
	return (
		<div className="w-full min-w-0 max-w-full text-gray-800 dark:text-dark-text">
			{!isSubmitted && (
				<div className="text-2xl font-bold text-gray-800 dark:text-dark-text pb-6">
					Report an issue
				</div>
			)}
			{isSubmitted ? (
				<div className="flex flex-col items-center justify-center h-36">
					{/* Success Icon */}
					<i className="fa-regular fa-circle-check text-green-500 text-3xl" />
					{/* Success Message */}
					<h2 className="text-xl text-green-600 dark:text-green-400">Saved.</h2>
					<p className="text-gray-600 dark:text-gray-300 text-center mt-6">
						Thank you! We'll be in touch with you soon.
					</p>
				</div>
			) : (
				<FormSection>
					<Label htmlFor="name">Name *</Label>
					<TextInput
						id="name"
						name="name"
						value={name}
						onChange={onChange}
						fieldErrors={errors}
						tailwindStyles="bg-white dark:bg-dark-bg text-gray-800 dark:text-dark-text border-gray-300 dark:border-dark-border"
					/>
					<Label htmlFor="email">Email *</Label>
					<EmailInput
						id="email"
						name="email"
						value={email}
						onChange={onChange}
						fieldErrors={errors}
						tailwindStyles="bg-white dark:bg-dark-bg text-gray-800 dark:text-dark-text border-gray-300 dark:border-dark-border"
					/>
					<Label htmlFor="description">Description of the issue *</Label>
					<TextArea
						id="description"
						name="description"
						value={description}
						onChange={onChange}
						fieldErrors={errors}
						tailwindStyles="bg-white dark:bg-dark-bg text-gray-800 dark:text-dark-text border-gray-300 dark:border-dark-border"
					/>
				</FormSection>
			)}
			{!isSubmitted && (
				<div className="grid">
					<div className="mt-4">
						<FormSubmit onSubmit={onSubmit} label="Submit" />
					</div>
				</div>
			)}
		</div>
	);
};

export default IssueForm;
